import React from "react";
import styled from "styled-components";

const UnsupportedDevice = () => {
    return (
        <Page>
            <Card>
                <Title>Desktop Required</Title>
                <Message>
                    This web app is only available on desktop. Please open it from a desktop or laptop browser.
                </Message>
            </Card>
        </Page>
    );
}

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8faff;
`;

const Card = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 36px 28px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(83, 110, 236, 0.14);
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 0 16px;
  font-family: Open Sans, sans-serif;
  font-size: 28px;
  line-height: 1.25;
  color: #536EEC;
`;

const Message = styled.p`
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-size: 18px;
  line-height: 1.5;
  color: #303030;
`;

export default UnsupportedDevice;
